import React, { createContext, useState, useContext } from 'react';

const SuiteContext = createContext();

export const SuiteProvider = ({ children }) => {
    const [suiteId, setSuiteId] = useState('');
    const [suiteList, setSuiteList] = useState([]);

    return (
        <SuiteContext.Provider value={{ suiteId, setSuiteId, suiteList, setSuiteList }}>
            {children}
        </SuiteContext.Provider>
    );
};

export const useSuite = () => useContext(SuiteContext);
